import React from 'react';

const TermsOfService = () => {
  return (
    <div className="text-sm text-gray-700 h-40 overflow-y-auto border border-gray-300 p-4 rounded-lg">
      <h3 className="font-bold mb-2">Terms of Service</h3>
      <p className="mb-2">Welcome to AisenHour. By using our service, you agree to the following terms:</p>
      <ol className="list-decimal list-inside space-y-2">
        <li>You must be at least 13 years old to use this service.</li>
        <li>You are responsible for maintaining the confidentiality of your account information.</li>
        <li>You agree not to use the service for any illegal or unauthorized purpose.</li>
        <li>We reserve the right to modify or terminate the service for any reason, without notice, at any time.</li>
        <li>We reserve the right to alter these Terms of Service at any time.</li>
        <li>All content you submit, upload, or display on or through the service is your responsibility.</li>
        <li>You retain your rights to any content you submit, post or display on or through the service.</li>
        <li>We may use your feedback, suggestions, or ideas in any way, including future modifications of the service, without any compensation to you.</li>
        <li>You agree that we are not responsible for any third-party content you access through the service.</li>
        <li>The service is provided "as is" without warranty of any kind.</li>
      </ol>
    </div>
  );
};

export default TermsOfService;